import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export const EmptyState = ({
  title,
  description,
  action,
  variant = 'outlined',
}: {
  title: ReactNode;
  description?: ReactNode;
  // Shown under the text, such as the button that fills the empty place.
  action?: ReactNode;
  // Plain has no frame of its own, for a page or a grid that already has one.
  variant?: 'outlined' | 'plain';
}) => {
  return (
    <Box
      p={2}
      textAlign="center"
      sx={{
        width: '100%',
        ...(variant === 'outlined' && {
          border: theme => `1px solid ${theme.palette.divider}`,
          borderRadius: borderRadius('m'),
          backgroundColor: theme => theme.palette.action.hover,
        }),
      }}
    >
      <Stack spacing={3}>
        <Stack>
          <Typography variant="h6">{title}</Typography>
          {description ? (
            <Typography variant="body2" color="textSecondary">
              {description}
            </Typography>
          ) : null}
        </Stack>
        {action ? <Box>{action}</Box> : null}
      </Stack>
    </Box>
  );
};
